import React, { useCallback } from 'react';

import { useSnackbar } from 'notistack';
import fileDownload from 'react-file-download';

import { Button } from '@mui/material';

import type { AgentTableRow } from '~/components/SmsVerifyStats/smsVerifyStatsUtils';

interface AiSummaryStatsCsvExportProps {
  tableData: Array<AgentTableRow>;
}

export default function AiSummaryStatsCsvExport({ tableData }: AiSummaryStatsCsvExportProps) {
  const { enqueueSnackbar } = useSnackbar();

  const handleExportCsv = useCallback(() => {
    if (!tableData.length) {
      enqueueSnackbar('No data to export', { variant: 'warning' });
      return;
    }

    const dateHeaders = tableData[0].dayCounts.map((dayCount) => dayCount.date);
    const headers = ['Email', ...dateHeaders, 'Total'];

    const rows = tableData.map((row) => [
      row.email,
      ...row.dayCounts.map((dayCount) => dayCount.count.toString()),
      row.total.toString(),
    ]);

    const escapeCsvValue = (value: string): string => {
      if (value.includes(',') || value.includes('"') || value.includes('\n')) {
        return `"${value.replace(/"/g, '""')}"`;
      }

      return value;
    };

    const csvLines = [headers.map(escapeCsvValue).join(','), ...rows.map((row) => row.map(escapeCsvValue).join(','))];
    const csvContent = csvLines.join('\n');
    const timestamp = new Date().toISOString().split('T')[0];

    fileDownload(csvContent, `genesys-call-summary-stats-${timestamp}.csv`);
    enqueueSnackbar('CSV exported successfully', { variant: 'success' });
  }, [enqueueSnackbar, tableData]);

  return (
    <Button variant="contained" color="primary" onClick={handleExportCsv}>
      Export CSV
    </Button>
  );
}
